<template>
  <div id="production-info">
    <div class="view-controls">
      <input
        class="production-filter"
        :class="{ 'preperation-filter': preperation }"
        type="text"
        :placeholder="$t('production_info.filter')"
        v-model="filter"
        @input="isChangingFilter = true"
      />
      <input
        class="preperation-type"
        v-if="preperation"
        type="text"
        :placeholder="$t('production_info.type')"
        v-model="type"
        @input="isChangingType = true"
      />
      <button
        v-if="preperation"
        type="button"
        class="btn btn-sm prepared-toggle-button"
        :class="{ 'btn-primary': preparedOnly, 'btn-secondary': !preparedOnly }"
        @click="togglePrepared"
      >
        Žinoma data
      </button>
      <button
        v-if="preperation"
        :disabled="selected.length == 0"
        type="button"
        class="btn btn-primary btn-sm floating-export-button"
        @click="downloadPreperationCsv"
      >
        <v-icon small color="white">archive</v-icon>
      </button>
      <button
        v-if="preperation"
        :disabled="selected.length == 0"
        type="button"
        class="btn btn-primary btn-sm floating-pdf-button"
        @click="printPreperationPdf"
      >
        <v-icon small color="white">print</v-icon>
      </button>
      <button
        v-if="preperation"
        :disabled="selected.length == 0"
        type="button"
        class="btn btn-primary btn-sm floating-button"
        @click="openOperationsMaker"
      >
        {{ $t("production_info.to_production") }}
      </button>
    </div>
    <div class="rTable" v-if="rows.length > 0 && loaded">
      <div class="rTableRow">
        <div class="rTableHead" v-if="preperation">
          <input
            id="preperation-select-all"
            type="checkbox"
            @input="selectAll($event.target.checked)"
          />
        </div>
        <div class="rTableHead">Užsakymas</div>
        <div class="rTableHead">Klientas</div>
        <div v-if="preperation" class="rTableHead">Vadyb</div>
        <div v-if="preperation" class="rTableHead">Tipas</div>
        <div v-if="preperation" class="rTableHead">Plotas</div>
        <div v-if="preperation" class="rTableHead">Med</div>
        <div v-if="preperation" class="rTableHead">Daž</div>
        <div v-if="preperation" class="rTableHead">Kabl</div>
        <div v-if="preperation" class="rTableHead">Špros</div>
        <div
          class="rTableHead supplier-cell"
          v-for="(supplier, i) in showingSuppliers"
          :key="i + 1000"
        >
          {{ supplier.short_title }}
        </div>
        <div class="rTableHead supplier-cell" v-if="preperation">
          {{ $t("production_info.other") }}
        </div>
        <div
          class="rTableHead"
          v-for="(center, index) in workCenters"
          :key="index"
          @click="viewWorkCenter(center)"
          @auxclick="openWorkCenterInNewWindow(center)"
        >
          <div class="rotate">{{ center.description }}</div>
        </div>
        <div class="rTableHead" v-if="preperation">Galima paleidimo data</div>
        <div class="rTableHead">Terminas</div>
      </div>
      <div
        class="rTableRow order-row"
        :class="getClass(row)"
        v-for="(row, i) in rows"
        :key="i"
      >
        <div
          class="rTableCell"
          v-for="(cell, j) in row.cells"
          :key="j"
          :class="cell.style"
          :style="cell.custom_style"
          @click="toggle($event, row, cell)"
          @mouseenter="preview($event, cell, row)"
          @mouseleave="mouseIsOver = -1"
          @contextmenu="showContextMenu($event, cell, row)"
        >
          <span v-if="cell.number == -1 && row.getType() == 'order'">
            <input
              class="preperation-checkbox"
              type="checkbox"
              @input="selectOrder($event.target.checked, row.object)"
            />
          </span>
          <span v-else>
            <span class="date-change" v-if="!cell.other && cell.date_cell">{{
              cell.text
            }}</span>
            <span v-else>{{ cell.text }}</span>
          </span>
        </div>
      </div>
    </div>
    <CommentsPreviewDialog
      ref="commentsPreviewDialog"
      @commentCreated="initialize"
    />
    <v-menu
      v-model="showMenu"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
    >
      <div v-if="deleteDate">
        <v-list>
          <v-list-tile v-if="deleteDate" @click="removeDate">
            <v-list-tile-title>{{
              $t("production_info.clean")
            }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </div>
      <div v-else-if="addSupplierFromSuppliersList">
        <v-list>
          <v-list-tile @click="selectSupplier">
            <v-list-tile-title>{{
              $t("production_info.add_supplier")
            }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </div>
      <div v-else-if="addingSupplier">
        <v-list>
          <v-list-tile @click="addSupplier">
            <v-list-tile-title>{{
              $t("production_info.add_supplier")
            }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </div>
      <div v-else>
        <v-list>
          <v-list-tile v-if="creating" @click="addOperation">
            <v-list-tile-title>{{
              $t("production_info.create")
            }}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-else @click="removeOperation">
            <v-list-tile-title>{{
              $t("production_info.delete")
            }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </div>
    </v-menu>
    <DatePicker ref="datePicker" @dateSelected="saveDate" />
    <OrderSupplierDialog
      ref="orderSupplierDialog"
      v-if="preperation"
      :suppliers="allSuppliers"
      @supplierAdded="initialize"
    />
  </div>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue";
import Helper from "@/models/Helper.js";
import Order from "@/models/Order.js";
import Operation from "@/models/Operation.js";
import User from "@/models/User.js";
import PreperationPdf from "@/models/PreperationPdf.js";
import Row from "@/models/ProductionTableRow.js";
import CommentsPreviewDialog from "@/components/production-planning/CommentsPreviewDialog.vue";
import OrderSupplierDialog from "@/components/production-planning/OrderSupplierDialog.vue";
import Export from "@/models/Export.js";
export default {
  props: {
    workCenters: Array,
    preperation: Boolean,
    testing: Boolean,
    showingSuppliers: {
      type: Array,
      default: () => {
        return [];
      },
    },
    allSuppliers: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      user: new User(this.$session.get("user")),
      opened: [],
      orders: [],
      filter: "",
      rows: [],
      selectedProduct: null,
      mouseIsOver: -1,
      showMenu: false,
      x: 0,
      y: 0,
      creating: true,
      deleteDate: false,
      editingCell: {},
      editingRow: {},
      showingWorkCenters: [],
      loaded: true,
      selected: [],
      isChangingFilter: false,
      filterTimer: 0,
      type: "",
      isChangingType: false,
      typeTimer: 0,
      addSupplierFromSuppliersList: false,
      addingSupplier: false,
      preparedOnly: localStorage.getItem("prepared-only") === "true",
    };
  },
  watch: {
    mouseIsOver(val) {
      if (val == -1 && this.selectedProduct != null) {
        this.selectedProduct = null;
        this.$emit("hideProduct");
      }
    },
    isChangingFilter(val) {
      if (!val) {
        this.search();
      }
    },
    filter() {
      clearTimeout(this.filterTimer);
      this.filterTimer = setTimeout(() => {
        this.isChangingFilter = false;
      }, 500);
    },
    isChangingType(val) {
      if (!val) {
        this.search();
      }
    },
    type() {
      clearTimeout(this.typeTimer);
      this.typeTimer = setTimeout(() => {
        this.isChangingType = false;
      }, 500);
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      const statusFrom = this.preperation ? 4 : 5;
      const statusTo = this.preperation ? 4 : 6;
      let orders = [];
      if (this.testing) {
        orders = await Order.getOrdersInProduction1(
          this.filter,
          this.type,
          statusFrom,
          statusTo,
          this.orders
        );
      } else {
        orders = await Order.getOrdersInProduction(
          this.filter,
          this.type,
          statusFrom,
          statusTo,
          this.orders
        );
      }
      this.orders = this.filterOrders(orders);
      this.getRows();
      this.loaded = true;
    },

    filterOrders(orders) {
      return orders.filter((order) => {
        if (!this.prepareration) {
          return true;
        }
        if (!this.preparedOnly) {
          return true;
        }
        const possibleDate = order.getPossibleStartDate(this.workCenters);
        const date = new Date(possibleDate);
        return date != "Invalid Date" ? true : false;
      });
    },

    getRows() {
      this.rows = Row.getRows(
        this.orders,
        this.workCenters,
        this.preperation,
        this.showingSuppliers
      );
    },

    search() {
      this.selectAll(false);
      this.initialize();
    },

    async openOperationsMaker() {
      this.$emit("toProduction", this.selected);
    },

    async printPreperationPdf() {
      const preperationPdf = new PreperationPdf(
        this.selected,
        this.rows,
        this.showingSuppliers
      );
      preperationPdf.generatePdf();
      await Export.customPdf(preperationPdf.getRows());
      this.selectAll(false);
    },

    async downloadPreperationCsv() {
      await Export.preperationCsv(this.selected);
      this.selectAll(false);
    },

    togglePrepared() {
      this.preparedOnly = !this.preparedOnly;
      localStorage.setItem("prepared-only", this.preparedOnly);
      this.initialize();
      this.selectAll(false);
    },

    /**
     * refresh window after launching into production
     */
    updateScreen() {
      this.selected = [];
      this.initialize();
    },

    /**
     * checks how to display row
     * @param row - row we are checking
     */
    getClass(row) {
      if (row.type === "order") {
        return {
          clickable: true,
        };
      }
      if (row.type === "product") {
        return {
          "products-column": true,
        };
      }
    },

    /**
     * adjusts the productions array to show
     * or hide selected order production
     * @param order - order from productions array
     */
    toggle(event, row, cell) {
      if (cell.suppliers && cell.other) {
        this.$emit("openDateChanger", row.object, cell.suppliers);
        return;
      }
      if (cell.suppliers && !cell.other && cell.suppliers.length > 0) {
        if (this.$refs.datePicker) {
          this.$refs.datePicker.open(event, cell.suppliers);
        }
        return;
      }
      if (cell.suppliers) return;
      if (cell.number == -1) return;
      const object = row.object;
      if (!object) return;
      if ("count" in object) {
        this.selectAll(false);
        const orderIndex = this.orders.indexOf(object);
        this.orders[orderIndex].showProducts = !this.orders[orderIndex]
          .showProducts;
        this.getRows();
      } else {
        const workCenterId = cell.workCenterId;
        if (!workCenterId) return;
        const comments = row.object.getPreviewComments(workCenterId);
        const operation = object.getWorkCenterOperation(workCenterId);
        if (operation) {
          if (operation.status == 3) {
            this.$refs.commentsPreviewDialog.open(comments, operation);
          }
        }
      }
    },

    selectAll(checked) {
      const mainCheckbox = document.getElementById("preperation-select-all");
      if (mainCheckbox) {
        mainCheckbox.checked = checked;
      }
      const checkboxes = document.getElementsByClassName(
        "preperation-checkbox"
      );
      for (const row of this.rows) {
        if (row.getType() == "order") {
          this.selectOrder(checked, row.object);
        }
      }
      for (const checkbox of checkboxes) {
        checkbox.checked = checked;
      }
    },

    selectOrder(checked, order) {
      if (checked) {
        this.addSelected(order);
      } else {
        this.removeSelected(order);
      }
    },

    addSelected(order) {
      this.selected.push(order);
    },

    removeSelected(order) {
      const removeIndex = this.selected
        .map((e) => {
          return e.id;
        })
        .indexOf(order.id);
      if (removeIndex != -1) {
        this.selected.splice(removeIndex, 1);
      }
    },

    showContextMenu(e, cell, row) {
      e.preventDefault();
      this.showMenu = false;
      this.deleteDate = false;
      this.addSupplierFromSuppliersList = false;
      this.addingSupplier = false;
      if (this.user.type > 1) {
        return;
      }
      if (cell.suppliers && cell.other) {
        this.addSupplierFromSuppliersList = true;
        this.openMenu(e, cell, row);
        return;
      }
      if (row.type === "order") {
        if (cell.suppliers) {
          if (!cell.other && cell.suppliers.length > 0) {
            this.deleteDate = true;
            this.openMenu(e, cell, row);
          }
          if (cell.suppliers.length == 0 && !cell.other) {
            this.addingSupplier = true;
            this.openMenu(e, cell, row);
          }
        }
        return;
      }
      if (cell.style["empty-box"]) {
        this.creating = true;
      } else if (cell.style["uncompleted-box"]) {
        this.creating = false;
      } else {
        return;
      }
      this.openMenu(e, cell, row);
    },

    openMenu(e, cell, row) {
      this.closeDatePicker();
      this.editingCell = cell;
      this.editingRow = row;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },

    selectSupplier() {
      const order = this.editingRow.object;
      if (this.$refs.orderSupplierDialog) {
        this.$refs.orderSupplierDialog.open(order);
      }
    },

    async addSupplier() {
      const order = this.editingRow.object;
      const suppliers = [
        {
          supplier_id: this.editingCell.related_supplier.id,
          ordered_at: Helper.getCurrentDate(),
        },
      ];
      await order.addSuppliers(suppliers);
      this.initialize();
    },

    async addOperation() {
      const workCenterId = this.editingCell.workCenterId;
      const productId = this.editingRow.object.id;
      await Operation.createOperation({
        work_center_id: workCenterId,
        product_id: productId,
      });
      this.initialize();
    },

    async removeOperation() {
      const product = this.editingRow.object;
      const workCenterId = this.editingCell.workCenterId;
      const workCenterOperation = product.operations.find((operation) => {
        return operation.work_center_id === workCenterId;
      });
      await workCenterOperation.delete();
      this.initialize();
    },

    preview(event, cell, row) {
      if (cell.number == 1 && row.type == "product") {
        row.object.select(this);
      }
    },

    openWorkCenterInNewWindow(center) {
      let routeData = this.$router.resolve({
        name: "work-center",
        params: { id: center.id },
      });
      window.open(routeData.href, "_blank");
    },

    viewWorkCenter(center) {
      this.$router.push({
        name: "work-center",
        params: { id: center.id },
      });
    },

    openDeliveryDateChanger() {
      this.$emit("openDateChanger", this.selected);
    },

    closeDatePicker() {
      if (this.$refs.datePicker) {
        this.$refs.datePicker.manualClose();
      }
    },

    validateDate(cell) {
      return Helper.getDate(cell.text) != null;
    },

    async saveDate(date, suppliers) {
      const orderId = suppliers[0].order_id;
      const supplierId = suppliers[0].supplier_id;
      let allSuppliers = [...suppliers];
      //if clicked on order within selected orders, add selected orders
      const orderSelected = this.selected.find((order) => {
        return order.id === orderId;
      });
      if (orderSelected) {
        this.selected.forEach((order) => {
          allSuppliers = [
            ...allSuppliers,
            ...order.getOrderSuppliers(supplierId),
          ];
        });
      }
      //filter without selected with mouse
      let uniqueSuppliers = [];
      allSuppliers.forEach((supplier) => {
        if (!uniqueSuppliers.includes(supplier)) uniqueSuppliers.push(supplier);
      });
      this.saveSupplierDate(date, uniqueSuppliers);
    },

    async saveSupplierDate(date, suppliers) {
      //don't wait for changes
      for (const supplier of suppliers) {
        this.getSupplierCell(supplier).text = Helper.getShortDate(new Date(date));
      }
      for (const supplier of suppliers) {
        supplier.ordered_at = Helper.getDate(supplier.ordered_at);
        supplier.confirmed_delivery_date = date;
        await supplier.save();
      }
      this.initialize();
    },

    async removeDate() {
      for (const supplier of this.editingCell.suppliers) {
        await supplier.clearDate();
      }
      this.initialize();
    },

    getSupplierCell(supplier){
      const row = this.rows.find(row => {
        if(row.object.hasOwnProperty("production_id")){
          return row.object.id == supplier.order_id;
        }
      });
      const cell = row.cells.find(cell => {
        if(!cell.suppliers || cell.suppliers.length == 0) return false;
        return cell.suppliers.includes(supplier);
      });
      return cell;
    }
  },
  components: {
    DatePicker,
    CommentsPreviewDialog,
    OrderSupplierDialog,
  },
};
</script>

<style scoped>
.rTable {
  display: table;
  width: 100%;
}
.rTableRow {
  display: table-row;
}
.rTableHeading {
  display: table-header-group;
  background-color: #ddd;
}
.rTableCell,
.rTableHead {
  display: table-cell;
  padding: 3px 3px;
  border: 1px solid #999999;
}
.rTableHead:hover {
  cursor: pointer;
}
.rTableHeading {
  display: table-header-group;
  background-color: #ddd;
  font-weight: bold;
}
.rTableFoot {
  display: table-footer-group;
  font-weight: bold;
  background-color: #ddd;
}
.rTableBody {
  display: table-row-group;
}

.rotate {
  writing-mode: tb-rl;
  transform: rotate(-180deg);
  display: flex;
}

.failed-box {
  background: red;
}

.empty-box {
  background: white;
}

.completed-box {
  background: rgb(109, 185, 109);
}

.uncompleted-box {
  background: rgb(248, 248, 106);
  text-align: center;
  font-weight: 600;
}
.name-cell {
  width: 150px;
}
.customer-cell {
  width: 200px;
}
.empty-cell {
  height: 30px;
}
.products-column {
  opacity: 0.5;
}
.clickable {
  cursor: pointer;
}
.view-controls {
  position: relative;
}
.production-filter {
  position: relative;
  height: 30px;
  border: 2px solid black;
  width: calc(100%);
}
.production-filter::placeholder {
  font-weight: 600;
}
.preperation-check {
  position: absolute;
  right: 20px;
  font-weight: 600;
}
.checkbox-cell {
  width: 50px;
}
.preperation-filter {
  width: calc(100% - 900px);
}
.preperation-type {
  position: relative;
  height: 30px;
  border: 2px solid black;
  width: 200px;
}
.floating-button {
  float: right;
  width: 200px;
  height: 30px;
}
.floating-pdf-button {
  width: 200px;
  height: 30px;
  right: 200px;
  position: absolute;
}
.floating-export-button {
  right: 400px;
  width: 200px;
  height: 30px;
  position: absolute;
}
.pdf-button {
  float: right;
  right: 220px;
  top: -3px;
}
.supplier-cell {
  width: 50px;
}
.date-change {
  cursor: default;
}
.manager-cell,
.wood-cell,
.paint-cell,
.element-cell,
.spross-cell,
.area-cell {
  width: 60px;
}
.type-cell {
  width: 80px;
}
.completion-date-cell {
  width: 80px;
}
.supplier-cell,
.prepared-date-known {
  background: rgb(239, 255, 218);
}
.two-colored-paint,
.prepared-date-unknown {
  background: rgb(255, 213, 213);
}
.prepared-toggle-button {
  position: absolute;
  top: 0;
  width: 100px;
  height: 30px;
  right: 600px;
}
</style>